<template>
  <loading :loading="isLoading" message="Busy putting stolen stuff back">
    <error :error="error"/>
    <b-form-group label="Notification URI" description="Get this from the address bar when viewing the notification (ignoring the `/alerts/` prefix).">
      <b-form-input id="steal"
        v-model.trim="uri"
        type="text"
        required
        placeholder="electoral_roll_multiple_spd/1 ELM STREET|RG6 5JJ"></b-form-input>
    </b-form-group>
    <b-button variant="warning" @click="returnNotification" class="card-link">Unsteal now</b-button>
  </loading>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'

export default {
  components: { Loading, Error },
  data() {
    return {
      isLoading: false,
      error: null,
      uri: null,
    };
  },
  methods: {
    validated() {
      this.error = null;
      // required
      if ((this.uri || '').length === 0) {
        this.error = "Notification URI is required";
        return false;
      }
      // clean
      if (this.uri.indexOf('alerts/') !== -1) {
        this.uri = this.uri.substring('/alerts/'.length);
      }
      // trim slash prefixes
      while (this.uri.indexOf('/') === 0) {
        this.uri = this.uri.substring(1);
      }
      // trim hash prefixes
      while (this.uri.indexOf('#') === 0) {
        this.uri = this.uri.substring(1);
      }
      return true;
    },

    returnNotification() {
      if (!this.validated()) {
        return;
      }
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'UnstealNotification',
        parameters: {
          alert_uri: this.uri,
        },
      })
      .then(() => {
        this.uri = null;
        this.$store.dispatch('invalidateCache', 'alerts');
        this.$store.dispatch('invalidateCache', 'home');
        this.isLoading = false;
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },
  },
};
</script>
